export default "__VITE_ASSET__CkoccHVW__"